import { all } from 'redux-saga/effects';
import authWatcher from './auth/watcher';
import unitWatcher from './unit/watcher';
import contractWatcher from './contract/watcher';

export default function* rootSaga() {
    yield all([...authWatcher, ...unitWatcher, ...contractWatcher]);
}
